<template>
  <v-row :class="$vuetify.breakpoint.mdAndUp ? 'flex-nowrap' : ''">
    <v-col cols="12" sm="7" lg="8">
      <v-card class="half-radius pl-4 pr-5 py-9 shadow">
        <div class="overflow-y-auto overflow-x-hidden custom-scroll" style="height: 60vh">
          <v-form ref="form" @submit.prevent v-model="form">
            <v-row v-for="(question, index) in answers" :key="'Question ' + index" dense>
              <v-col cols="auto">
                <v-avatar size="27" color="#168EEA" class="white--text body-2 custom-avatar">{{
                  index + 1
                }}</v-avatar>
              </v-col>
              <v-col cols="auto" class="pl-7">
                <v-radio-group
                  class="mt-0"
                  hide-details
                  v-model="answers[index].content"
                  :readonly="finished"
                  :rules="[rules.required]"
                >
                  <v-radio
                    v-for="(answer, key, row) in JSON.parse(questions[index].content)"
                    :key="index + key + row"
                    :value="key"
                    class="custom-radio"
                    color="#29284c"
                  >
                    <template #label>
                      <span
                        :class="{
                          'font-weight-bold': answers[index].content === key,
                        }"
                        class="custom-text body-2"
                        >{{ answer }}</span
                      >
                    </template>
                    <template #default>mdi-radiobox-marked</template>
                  </v-radio>
                </v-radio-group>
              </v-col>
              <v-col
                cols="12"
                class="pl-8 pt-4 pr-4"
                :style="$vuetify.breakpoint.xs ? '' : 'padding-right: 60px !important'"
              >
                <v-divider class="custom-divider" v-if="index < questions.length - 1"></v-divider>
              </v-col>
            </v-row>
            <v-col class="text-center mt-6">
              <v-btn
                v-if="!finished"
                small
                depressed
                :disabled="!form || finished"
                width="100"
                :loading="loading"
                class="white--text text-capitalize"
                color="#29284c"
                @click="onFinish"
                >Finish</v-btn
              >
              <ProgressResetButton
                v-else
                :stepType="stepType"
                :stepUuid="stepUuid"
                @reset="handleReset"
              />
            </v-col>
          </v-form>
        </div>
      </v-card>
    </v-col>
    <v-spacer></v-spacer>
    <v-col>
      <app-answer-key split-char=")" hide-hint :finished="finished" :questions="questions" />
    </v-col>
  </v-row>
</template>
<script>
import AnswerKey from "./../AnswerKey.vue";
import studentMixin from "@/mixins/studentMixin";
import answerMixin from "@/mixins/answerMixin";
import ProgressResetButton from "@/components/Utils/ProgressResetButton.vue";

export default {
  components: {
    appAnswerKey: AnswerKey,
    ProgressResetButton,
  },
  mixins: [studentMixin, answerMixin],
  props: {
    stepUuid: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      form: false,
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },
  methods: {
    handleReset() {
      this.onReset();
      this.$refs.form.resetValidation();
    },
  },
};
</script>
<style scoped>
.custom-divider {
  border-top: 1px #29284c dashed;
}
.custom-avatar {
  border: 1px #c5eeff solid !important;
}
.v-avatar {
  margin-top: 2px;
}
.custom-scroll::-webkit-scrollbar {
  width: 7px;
}
.custom-scroll::-webkit-scrollbar-thumb {
  background: #29284c !important;
  border-radius: 20px;
}
</style>
